module.exports = __webpack_public_path__ + "img/q_btn.48e2ea91.png";